import { createSelector } from 'reselect'
import { floatify } from 'lib/maths/mathUtils'
import getDepositAmountBeforeCreditApplied from './getDepositAmountBeforeCreditApplied'
import getPayableTotal from '../getPayableTotal'
import getDiscountTotal, { getVoucherDiscountTotal } from '../getDiscountTotal'

const getDepositRemainingBeforeCreditApplied = createSelector(
  (state: App.State) => getPayableTotal(state),
  (state: App.State) => getDiscountTotal(state),
  (state: App.State) => getVoucherDiscountTotal(state),
  (state: App.State) => getDepositAmountBeforeCreditApplied(state),
  (total, discount, voucherDiscount, deposit): number => {
    return floatify(Math.max(total - discount - voucherDiscount - deposit, 0))
  },
)

export default getDepositRemainingBeforeCreditApplied
